const About = () => {
  return (
    <div className='about-section'>
      <h1>about footprint</h1>
      <p>
        This is a joint project by Hannah and James on their General Assembly
        Software Engineering Course.
      </p>
      <p>
        footprint gives users the means to see the impact their travels have on
        the environment, and learn what they would need to do in order to offset
        their carbon footprint.
      </p>
      <p>
        We would like to thank Robin Kerrison for allowing us the use of his{' '}
        <a href='https://github.com/rjkerrison/ticker-board'>
          {' '}
          tickerboard plug-in
        </a>
        .
      </p>
    </div>
  )
}

export default About
